import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import zh from './zh/translation.json';
import en from './en/translation.json';
i18n

  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options

  .init({
    resources: {
      'zh-CN': zh,
      en,
    },
    debug: true,
    fallbackLng: 'en', // use en if detected lng is not available
    ns: ['translation', 'candidates'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // TODO: 如果需要使用远程加载语言包, 则注释掉上面的resources, 并且打开下面的backend配置，需要安装i18next-http-backend依赖，更改webpack配置(打包到release/app/dist/renderer/locales)
    // backend: {
    //   loadPath: './locales/{{lng}}/{{ns}}.json',
    // },
  });

export default i18n;
